module.exports = __webpack_public_path__ + "static/media/search.8d2fb10c.svg";